import { useQuery } from '@tanstack/react-query';

interface OutreachStats {
  activePrograms: number;
  totalParticipants: number;
  locations: number;
  successRate: number;
}

async function fetchOutreachStats(): Promise<OutreachStats> {
  // Simulate API call
  await new Promise(resolve => setTimeout(resolve, 1000));
  
  return {
    activePrograms: 5,
    totalParticipants: 1250,
    locations: 8,
    successRate: 92,
  };
}

export function useOutreachStats() {
  return useQuery({
    queryKey: ['outreach-stats'],
    queryFn: fetchOutreachStats,
  });
}